import { render, staticRenderFns } from "./TopCharts.vue?vue&type=template&id=89db1862&scoped=true"
import script from "./TopCharts.vue?vue&type=script&lang=js"
export * from "./TopCharts.vue?vue&type=script&lang=js"
import style0 from "./TopCharts.vue?vue&type=style&index=0&id=89db1862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89db1862",
  null
  
)

export default component.exports